// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { AddonBin } from './addon-bin';
import { AddonBinStatusEnum } from './enums';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class AddonBinStatus extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Enum key */
  id!: AddonBinStatusEnum;
  /** String(30) */
  name!: string;
  /** Inv FK addonBinStatusId */
  addonBins!: AddonBin[];
}

